<template>
    <div class="modal-mask">
        <div :class="classDialog">
            <div class="modal-container">

                <div class="modal-header border-bottom">
                    <slot name="header">
                        default header
                    </slot>
                    <button type="button" class="close" aria-hidden="true" @click="close">×</button>
                </div>

                <div class="modal-body">
                    <slot name="body">
                        default body
                    </slot>
                </div>

                <div class="modal-footer">
                    <slot name="footer">
                        <button class="btn btn-primary float-left" @click="close">
                            Fechar
                        </button>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Modal",
        props: {
            classDialog: {
                type: String,
                required: false,
                default: 'modal-dialog'
            }
        },
        methods: {
            close(){
                this.$emit('close');
            }
        }
    }
</script>

<style lang="scss">
    .modal-light-dark {
        .modal-header {
            background-color: #38414aeb;
        }
        .close {
            color: white;
        }
    }
    .modal-mask {
        position: fixed;
        z-index: 1050;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        transition: opacity .3s ease;
        overflow: auto;
        display: block;
    }
    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
    .modal-container {
        position: relative;
        display: -webkit-box;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        width: 100%;
        pointer-events: auto;
        background-color: #fff;
        background-clip: padding-box;
        border: 0 solid transparent;
        border-radius: 0.2rem;
        outline: 0;
    }
    .modal-header h3 {
        margin-top: 0;
    }
    .modal-body {
        margin: 20px 0;
        overflow-y: auto;
    }
    .modal-default-button {
        float: right;
    }
    .modal-enter {
        opacity: 0;
    }
    .modal-leave-active {
        opacity: 0;
    }
    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>
